var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"bc167ab9da8b8b66be5ee498ee34e58ffaff83d0"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["webflow-js@sharesy"]={id:"bc167ab9da8b8b66be5ee498ee34e58ffaff83d0"};
      